import ErrorView from '@/components/shared/ErrorView';
import ApplicationSelector from '@/components/simulator/ApplicationSelector';

const InstanceView = () =>
  import(/* webpackChunkName: "InstaceView" */ '@/components/simulator/InstanceView');

export default [
  {
    path: '',
    name: 'DefaultView',
    redirect: { name: 'ApplicationSelector' },
  },
  {
    path: '/404',
    name: '404View',
    component: ErrorView,
  },
  {
    path: '/applications',
    name: 'ApplicationSelector',
    component: ApplicationSelector,
  },
  {
    path: '/instances/:id',
    name: 'InstanceView',
    component: InstanceView,
    props: true,
  },
];
